module.exports = __webpack_public_path__ + "img/yangxuerui.6597b95e.jpg";